import React from 'react';
import { BookOpenIcon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, ShieldCheckIcon, StarIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
type BenefitProps = {
  icon: React.ElementType;
  text: string;
  className?: string;
};
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" glow className="my-12 rounded-[2rem] border border-brand-gold/45 bg-brand-paper/70 shadow-[0_20px_55px_rgba(76,50,79,0.11)]" data-id="element-257" data-mp="1vv37d2la8qhh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-258" data-mp="1rut2jt988647">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-purple px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-259" data-mp="25t0ufmreoh8i">
          <StarIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-260" data-mp="3h6v6ztr0l6jh" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-261" data-mp="3c78j8qdk87wf">
          TU <span className="text-brand-purple" data-id="element-262" data-mp="3w08g2dow7wd0">MEGA PACK REIKI™</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-263" data-mp="4smf4stk67zu">
          El precio de lanzamiento cierra pronto. Después sube $20.000 ARS.
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-264" data-mp="9q5w40hn4yvh">
        <div className="rounded-3xl border-2 border-brand-gold/65 bg-brand-paper p-5 shadow-[0_14px_40px_rgba(139,105,55,0.14)] md:p-7" data-id="element-265" data-mp="erlbbbx50b5y">
          <div className="flex items-center gap-2 text-brand-goldDark" data-id="element-266" data-mp="3dasahbycpdpq">
            <TrophyIcon className="h-4 w-4" data-id="element-267" data-mp="3i8tubz3lph29" />
            <StarIcon className="h-3.5 w-3.5 fill-current" data-id="element-268" data-mp="3i5pl2nba3v4q" />
            <span className="text-[10px] font-bold uppercase tracking-[0.16em] md:text-xs" data-id="element-269" data-mp="3n5k8uhzrc4lk">
              El sistema más completo para tu consulta Reiki
            </span>
          </div>
          <div className="mt-4 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-270" data-mp="2uhek7k5l1vgg">
            <div data-id="element-271" data-mp="2zgiwwkrpubbj">
              <h3 className="font-serif text-xl font-bold text-brand-ink" data-id="element-272" data-mp="2zfzqa07in9ct">MEGA PACK REIKI™</h3>
              <p className="mt-1 text-sm text-brand-muted" data-id="element-273" data-mp="2rfa63qn76hgx">3 Tomos + 6 Bonos · 270 páginas de contenido profesional</p>
              <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-forest" data-id="element-274" data-mp="2mfp6rf44873o">
                El ecosistema definitivo para terapeutas que quieren dejar de improvisar y llevar su práctica al siguiente nivel.
              </p>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-275" data-mp="28j1vs8fbvger">
              <p className="text-sm text-brand-muted line-through" data-id="element-276" data-mp="23ixier9pv1sr">$95.000 ARS</p>
              <p className="font-serif text-3xl font-bold text-brand-purple" data-id="element-277" data-mp="23la5tjy8u4d7">$24.990 ARS</p>
            </div>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-278" data-mp="2dgu0k312mx0d">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-279" data-mp="3ox1tdcqpatyu">
            → QUIERO MI MEGA PACK REIKI™ $24.990
          </CTAButton>
        </motion.div>
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-5" aria-label="Beneficios de compra" data-id="element-280" data-mp="cghltatikwp">
          <Benefit icon={BookOpenIcon} text="Listo para imprimir o usar en tablet" data-id="element-281" data-mp="5740ncn1yn3w" />
          <Benefit icon={LockKeyholeIcon} text="Pago seguro" data-id="element-282" data-mp="3nh66k6b4bbew" />
          <Benefit icon={CreditCardIcon} text="Mercado Pago" data-id="element-283" data-mp="3rhq1d387y2xv" />
          <Benefit icon={DownloadIcon} text="100% PDF" data-id="element-284" data-mp="j0vdatw2yn3u" />
          <Benefit icon={ZapIcon} text="Acceso inmediato" className="col-span-2 sm:col-span-1" data-id="element-285" data-mp="j1esi2ucixe6" />
        </div>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-286" data-mp="nz6i2q7iq7f7">
          <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 text-brand-purple" data-id="element-287" data-mp="a7ib11c4m953" />
          Garantía de 7 días
        </p>
      </div>
    </Section>;
}
function Benefit({
  icon: Icon,
  text,
  className = ''
}: BenefitProps) {
  return <div className={`flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-purple/20 bg-brand-paper px-2 py-2 text-center ${className}`} data-id="element-288" data-mp="11yfx3mjzmvhl">
      <Icon className="h-4 w-4 text-brand-purple" aria-hidden="true" data-id="element-289" data-mp="3f8bjimm4vhvm" />
      <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-290" data-mp="3a7w5rtxxw8d4">{text}</span>
    </div>;
}